import { DashboardStats } from '../models/dashboard-stats.model';

export const MOCK_DASHBOARD_STATS: DashboardStats = {
  admins: 3,
  properties: 43,
  residents: 76,
  vendors: 12,
  amenityBookings: 7,
  petRegistries: 3,
};

